import React from 'react';
import RotatingHeroText from './RotatingHeroText';

const Header: React.FC = () => (
  <section
    aria-labelledby="hero-title"
    className="hero"
    id="Header"
  >
    <div
      aria-hidden="true"
      className="hero-grid"
    />
    <div className="landing-container hero-inner">
      <div className="hero-copy">
        <p className="eyebrow hero-eyebrow">
          <span className="status-dot" />
          {' '}
          РЕШЕНИЯ НА БАЗЕ ИИ. РАЗРАБОТКА. ИНТЕГРАЦИИ.
        </p>
        <h1 id="hero-title">
          Технологии,
          <br />
          которые
          <RotatingHeroText />
        </h1>
        <p className="hero-description">
          Внедряем ИИ для оптимизации процессов.
          <br />
          Разрабатываем приложения и интеграции под задачи бизнеса.
          <br />
          Создаём сервисы для клиентов и сотрудников.
        </p>
        <div className="hero-actions">
          <a
            className="hero-action hero-action-primary"
            href="#AI"
          >
            <span>Примеры автоматизации</span>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Header;
